import HooksModalV5Key from "app/constants/HooksModalV5Key";
import FeatureUpgradeBanner from "app/pages/sales-intelligence/common-components/feature-upgrade/components/FeatureUpgradeBanner/FeatureUpgradeBanner";
import FeatureUpgradeBannerRow from "app/pages/sales-intelligence/common-components/feature-upgrade/components/FeatureUpgradeBanner/FeatureUpgradeBannerRow";
import { featureHookKeys } from "app/pages/sales-intelligence/utils/i18n/feature-hook";
import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

import trackingService from "../../services/tracking/trackingService";

type Layout = "column" | "row";
type Variant = "search" | "company" | "column";

type Props = {
    variant: Variant;
    isSubmitted: boolean;
    onSubmit: VoidFunction;
};

const ConversionRateBanner = ({ isSubmitted, variant, onSubmit }: Props) => {
    const resolvedLayout: Layout = variant === "company" ? "row" : "column";

    const handleSubmit = () => {
        trackingService.trackFeatureAccessRequested(HooksModalV5Key.SalesConversionRate);
        void requestFeature(HooksModalV5Key.SalesConversionRate);

        onSubmit();
    };

    const variantKeys = featureHookKeys.conversionRate[variant];
    const bannerProps = {
        headerKey: variant === "column" ? featureHookKeys.conversionRate.column.header : undefined,
        titleKey: variantKeys.upgradeTitle,
        subtitleKey: variantKeys.upgradeDescription,
        buttonTextKey: featureHookKeys.contactUsCta,
        isSubmitted,
        onSubmit: handleSubmit,
    };

    return resolvedLayout === "row" ? (
        <FeatureUpgradeBannerRow {...bannerProps} />
    ) : (
        <FeatureUpgradeBanner {...bannerProps} />
    );
};

export default ConversionRateBanner;
